import { initApp } from './app';

const app = document.getElementById('app');
if (app) {
  initApp(app);
}
